import {
    WALLET_RECHARGE_LINK,
} from '../../constants/api-constants';
import httpClient from '../../utils/http-client';

export const getPaymentLink = (userId: string, params: any) => {
    return httpClient.post(
		WALLET_RECHARGE_LINK.replace('$userId', userId),
		params
	);
};
  